import api from '../..'

const getCourseDataToDuplicate = (courseId: number) => {
  return api.get(`administration/duplicateds/${courseId}`).then(({ data }) => data)
}

export default getCourseDataToDuplicate
